import { Component, OnInit, Input, ChangeDetectorRef, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, FormArray, UntypedFormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ECalendarValue, IDatePickerConfig, } from 'ng2-date-picker';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTimeFieldComponent } from './componenets/custom-time-field/custom-time-field.component';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-custom-timeRange',
    templateUrl: './custom-timeRange.component.html',
    styleUrls: ['./custom-timeRange.component.scss'],
    standalone: true,
    imports: [
        MatFormFieldModule,
        CustomTimeFieldComponent,
        TranslateModule,
    ],
})
export class CustomTimeRangeComponent implements OnInit {
    constructor(private ref: ChangeDetectorRef, private fb: UntypedFormBuilder) {}
    ngOnInit(): void {
        this.date.valueChanges.subscribe((val)=>{
            this.initTime();
        })
        this.initTime();

        this.time.get('start').valueChanges.subscribe((value)=>{
            if (this.time.get('end').value < value) this.time.get('end').setValue(value);
            this.endMin = value;
        });

        this.time.get('end').valueChanges.subscribe((value)=>{
            if (this.time.get('start').value > value) this.time.get('start').setValue(value);
            this.startMax = value;
        });

    }

    @Input() availableFrom: Date;

    @Input() availableTo: Date;

    @Input() date: UntypedFormControl;

    @Input()time = this.fb.group({
        start: [null],
        end: [null]
    });

    startMax;

    endMin;


    initTime = () => {
        this.time.patchValue({
            start : _.cloneDeep(this.availableFrom),
            end: _.cloneDeep(this.availableTo)
        });

        this.startMax = _.cloneDeep(this.availableTo);
        this.endMin = _.cloneDeep(this.availableFrom);

    }



}
